<!--  -->

<div class="full-height">
  <div class="login-left">
    <div class="login-left-inner">
      <div class="login-logo">
        <a routerLink="/">
        <img src="/assets/img/new-logo.png"/>
        </a>
      </div>

      <ul>
        <li>
          <span>
            <img src="/assets/img/icon-24.png "/>
          </span>
        24/7 Online ordering access</li>
        <li><span>
          <img src="/assets/img/box-icon.png " />
        </span>Manage orders from multiple suppliers</li>
        <li><span>
          <img src="/assets/img/order-icon.png " />
        </span>Order history, tracking and invoices</li>
        <li><span>
          <img src="/assets/img/folder-icon.png " />
        </span>Live inventory and pricing</li>
      </ul>
    </div>
  </div>

  <div class="login-right">
    <div class="login-right-inner">
      <div class="login-right-scroll overflow-auto">
      <div class="login-box">

        <div *ngIf="loginform">
          <app-login-form (showSignUp)="showSignUp()"></app-login-form>
        </div>

        <div *ngIf="signupform" id="signUpForm">
          <h3 class="small-30">Register your business</h3>
          <form class="signup-form" [formGroup]="form" (ngSubmit)="onRegister()">

            <p class="label">
              Business Name
            </p>
            <input type="text" formControlName="business_name" class="form-control s-form-field" placeholder="Business Name" />
            <span *ngIf="form.get('business_name').touched || form.get('business_name').dirty">
              <span class="error" *ngIf="form.get('business_name').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('business_name').hasError('maxlength')">Maximum 50 characters are allowed</span>
            </span>

            <!-- <p class="label">
              Full Name
            </p>
            <input type="text" formControlName="name" class="form-control s-form-field" placeholder="Enter Your Full Name" />
            <span *ngIf="form.get('name').touched || form.get('name').dirty">
              <span class="error" *ngIf="form.get('name').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('name').hasError('maxlength')">Maximum 20 characters are allowed</span>
            </span> -->
            <p class="label">
              Email
            </p>
            <input formControlName="email" type="email" class="form-control s-form-field"
              placeholder="Enter Your Email Address" />
            <span *ngIf="form.get('email').touched || form.get('email').dirty">
              <span class="error" *ngIf="form.get('email').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('email').hasError('email')">Email is invalid</span>
            </span>
            <p class="label">
              Password
            </p>
            <input type="password" formControlName="password" class="form-control s-form-field"
              placeholder="Enter Your Password" />
            <span *ngIf="form.get('password').touched || form.get('password').dirty">
              <span class="error" *ngIf="form.get('password').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('password').hasError('minlength')">Minimum 06 characters are allowed</span>
            </span>


            <p class="label">
              Country
            </p>
            <select class="form-control custom-input" formControlName="country" (change)="onCountrySelect($event)">
              <option value="" disabled>Select Country</option>
              <option *ngFor="let country of countries" [selected]="country.id == 233" [value]="country.countryName">{{ country.countryName }}</option>
            </select>
            <span *ngIf="form.get('country').touched || form.get('country').dirty">
              <span class="error" *ngIf="form.get('country').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('country').hasError('maxlength')">Maximum 50 characters are allowed</span>
            </span>


            <p>
              Register as
            </p>
            <div class="d-flex">
              <div class="radio-style">
                <input type="radio" (change)='isVendor = !isVendor' formControlName="type" class="form-control s-form-field" value="Retailer" /> Dealer
              </div>
              <div class="radio-style">
                <input type="radio" formControlName="type" (change)='isVendor = !isVendor' class="form-control s-form-field" value="Brand" /> Supplier
              </div>
            </div>
            <span *ngIf="form.get('type').touched || form.get('type').dirty">
              <span class="error" *ngIf="form.get('type').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('type').hasError('maxlength')">Maximum 50 characters are allowed</span>
            </span>

            <ng-template [ngIf]="!isVendor">
              <p class="label">
                Plan
              </p>
              <select class="form-control custom-input" formControlName="plan">
                <option value="" disabled>Select Plan</option>
                <option *ngFor="let plan of plans" [value]="plan.slug">{{
                  plan.name }} ({{ plan.price > 0? (plan.price + ' USD / Month') : 'Free'}})</option>
              </select>
              <span *ngIf="form.get('plan').touched || form.get('plan').dirty">
                <span class="error" *ngIf="form.get('plan').hasError('required')">This field is required</span>
              </span>
            </ng-template>

            <p *ngIf="!isVendor" class="label">Upload License</p>
            <p *ngIf="isVendor" class="label">Upload Business Logo</p>
            <div class="d-flex mt-2">
              <span class="upload-icon mr-3">
                <img src="../../../assets/img/upload-icon.png"/>
              </span>
              <input (change)="onFileChange($event)" accept=".jpeg, .png, .jpg, .pdf" type="file" id="fileInput" class="form-control s-form-field file-field" />

            </div>

            <span *ngIf="form.get('trade_license').touched || form.get('trade_license').dirty">
              <span class="error" *ngIf="form.get('trade_license').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('trade_license').hasError('maxlength')">Maximum 50 characters are allowed</span>
            </span>



             <div class="d-flex hide-border align-items-center">
              <input type="checkbox" formControlName="termCheckbox" />
              <p>I agree to the <a data-toggle="modal" data-target="#termsofService">{{termTitle}}</a></p>
            </div>
            <span *ngIf="form.get('termCheckbox').touched || form.get('termCheckbox').dirty">
              <span class="error" *ngIf="form.get('termCheckbox').hasError('required')">This field is required</span>
            </span>

            <div class="d-flex hide-border align-items-center">
              <input type="checkbox" formControlName="privacyCheckbox" />
              <p>I agree to the <a data-toggle="modal" data-target="#privacypolicy">{{privacyTitle}}</a></p>
            </div>
            <span *ngIf="form.get('privacyCheckbox').touched || form.get('privacyCheckbox').dirty">
              <span class="error" *ngIf="form.get('privacyCheckbox').hasError('required')">This field is required</span>
            </span>



            <p class="small-text f-light">Already Register <a (click)="showSignIn()" class="cursor-pointer">Log In</a> </p>
            <button type="submit" class="btn btn-01 mt-4 new-btn bg-black" [disabled]="registerProcessing">
              <app-preloader *ngIf="registerProcessing" [size]="'sm'"></app-preloader>
              <span *ngIf="!registerProcessing" class="cursor-pointer">Register</span>
            </button>

          </form>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>

<!-- <section class="mb-5">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 mt-5">
        <app-login-form></app-login-form>
      </div>
      <div class="col-md-6 mt-5">
        <h3 class="small-30 ml-lg-4">New to  TunerStop</h3>
        <form class="signup-form" [formGroup]="form" (ngSubmit)="onRegister()">
          <p>
            Full Name
          </p>
          <input type="text" formControlName="name" class="form-control s-form-field" placeholder="Enter Your Full Name" />
          <span *ngIf="form.get('name').touched || form.get('name').dirty">
            <span class="error" *ngIf="form.get('name').hasError('required')">This field is required</span>
            <span class="error" *ngIf="form.get('name').hasError('maxlength')">Maximum 20 characters are allowed</span>
          </span>
          <p>
            Email Address
          </p>
          <input formControlName="email" type="email" class="form-control s-form-field" placeholder="Enter Your Email Address" />
          <span *ngIf="form.get('email').touched || form.get('email').dirty">
            <span class="error" *ngIf="form.get('email').hasError('required')">This field is required</span>
            <span class="error" *ngIf="form.get('email').hasError('email')">Email is invalid</span>
          </span>
          <p>
            Password
          </p>
          <input type="password" formControlName="password" class="form-control s-form-field" placeholder="Enter Your Password" />
          <span *ngIf="form.get('password').touched || form.get('password').dirty">
            <span class="error" *ngIf="form.get('password').hasError('required')">This field is required</span>
            <span class="error" *ngIf="form.get('password').hasError('minlength')">Minimum 06 characters are allowed</span>
          </span>
          <p class="small-text f-light" style="font-size:16px">By joing you agree with our terms and privacy policy</p>
          <button type="submit" class="btn btn-01 mt-4 text-uppercase" [disabled]="registerProcessing">
            <app-preloader *ngIf="registerProcessing" [size]="'sm'"></app-preloader>
            <span *ngIf="!registerProcessing">Sign Up</span>
          </button>
        </form>
      </div>
    </div>


  </div>
</section> -->
<!--  -->


<!-- Terms of Service Modal -->
<div class="modal fade small-modal" id="termsofService" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ termTitle }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [innerHTML]="termBody">
      </div>
    </div>
  </div>
</div>

<!-- Privacy Policy Modal -->
<div class="modal fade small-modal" id="privacypolicy" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ privacyTitle }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [innerHTML]="privacyBody">
      </div>
    </div>
  </div>
</div>
